import { Hide, Show } from '@chakra-ui/react'
import React from 'react'

import { naturalResolutionMap } from '~shared-components/chakra-theme/foundations/breakpoints'
import { RouterLinkProps } from '~shared-components/components'

import DesktopHeader from './DesktopHeader'
import MobileHeader from './MobileHeader'

export interface HeaderProps {
  cartLink?: RouterLinkProps['to']
  environmentTag?: React.ReactElement
  homeLink: RouterLinkProps['to']
  isCsrUi?: boolean
  isLoggedIn: boolean
  onLogout?: () => void
  profileLink?: RouterLinkProps['to']
  search?: React.ReactElement
  topMenuLinks: React.ReactNode[]
}

export interface HeaderTranslation {
  callUs: string
  logout: string
  myProfile: string
  phoneNumber: string
  preferences: string
  profile: string
}

export const Header = (props: HeaderProps) => (
  <>
    <Show above={naturalResolutionMap['tablet']}>
      <DesktopHeader {...props} />
    </Show>
    <Hide above={naturalResolutionMap['tablet']}>
      <MobileHeader {...props} />
    </Hide>
  </>
)
